import {setFieldVisibility} from "../../../../../apps/KpModule/actions";
import {generateFetchFieldListAction, GET_OBJECT_SUCCESS} from "../../../../../apps/KpModule/actions/api";
import _ from "lodash";

export const module_ = {
    object: 'Payment',
    name: 'ReliefFundPaymentValidation',
    tKey: 'mTitle_liberationManagement',
    category: {path: 'menuTitle_reliefFund', icon: 'heartHandshake'},
    newable: false,
    removable: false,
    viewMap: {
        dt: [
            { path: 'reliedFundApplicationNumber', tKey: 'applicationNumber', width: 120 },
            {path: 'organizationTradingName', tKey: 'tradingName'},
            { path: 'object', initiallyNotVisible: true },
            { path: 'natureOfHelpWithUnit', tKey: 'type', translate: true },
            { path: 'awardedAmountInEuros', tKey: 'awardedInEuros', width: 120, tooltip: true },
            { path: 'proposedAmountInEuros', width: 120, tooltip: true },
            { path: 'awardedAmountInKilograms', width: 120, tooltip: true },
            { path: 'proposedAmountInKilograms', width: 120, tooltip: true },
            { path: 'status', type: 'status', fieldPath: ['id', 'name', 'bStyle'], translate: true },
            { path: 'paymentDate', tKey: 'Libération effectuée le', initiallyNotVisible: true},
        ],
        form: [
            { path: 'reliedFundApplicationNumber', tKey: 'applicationNumber', editable: false},
            {path: 'organizationTradingName', tKey: 'tradingName', editable: false},
            { path: 'object', editable: false },
            { path: 'natureOfHelpWithUnit', tKey: 'type', translate: true, editable: false},
            { path: 'awardedAmountInEuros', tKey: 'awardedInEuros', editable: false },
            { path: 'proposedAmountInEuros', editable: false },
            { path: 'awardedAmountInKilograms', editable: false },
            { path: 'proposedAmountInKilograms', editable: false },
            { path: 'comments', tKeyText: 'Suivi', disabled: true },
            { path: 'account', hidden: true },
            { path: 'status', hidden: true },
            { path: 'buttons', hidden: true }
        ]
    },
    filters: ['byAcceptedFiles', 'byStatus', 'userHasLiberationAuthorization'],
    actionSubscriptions: [
        {
            actionType: GET_OBJECT_SUCCESS,
            subscription: ({ store, module }) => {
                const state = store.getState()
                const awardedAmountInEuros = _.get(state, 'edit.object.data.awardedAmountInEuros')
                const awardedAmountInKilograms = _.get(state, 'edit.object.data.awardedAmountInKilograms')

                const awardedAmountInEurosField = module.viewMap.form.fields.find(field => field.path === 'awardedAmountInEuros')
                const awardedAmountInKilogramsField = module.viewMap.form.fields.find(field => field.path === 'awardedAmountInKilograms')
                const proposedAmountInEurosField = module.viewMap.form.fields.find(field => field.path === 'proposedAmountInEuros')
                const proposedAmountInKilogramsField = module.viewMap.form.fields.find(field => field.path === 'proposedAmountInKilograms')

                store.dispatch(setFieldVisibility(awardedAmountInEurosField.id, awardedAmountInEuros !== 0))
                store.dispatch(setFieldVisibility(proposedAmountInEurosField.id, awardedAmountInEuros !== 0))
                store.dispatch(setFieldVisibility(awardedAmountInKilogramsField.id, awardedAmountInKilograms !== 0))
                store.dispatch(setFieldVisibility(proposedAmountInKilogramsField.id, awardedAmountInKilograms !== 0))
            }
        }
    ]
}
